import React, { useEffect } from "react";

import { store } from "./app/store";
import AppRouter from "./router/AppRouter";
import "./styles/tailwind.css"; // Tailwind custom
import { setDeviceId, setSdkParams } from "./features/auth/authSlice";

const App: React.FC = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const mobileNumber = urlParams.get('mobileNumber');
    const userId = urlParams.get('userId');
    const urlDeviceId = urlParams.get('deviceId');
    const panNumber = urlParams.get('panNumber') || urlParams.get('pan') || urlParams.get('PAN');
    const emailId = urlParams.get('emailId') || urlParams.get('email') || urlParams.get('EMAIL');

    // Basic device ID initialization
    let deviceIdToUse = urlDeviceId || localStorage.getItem("deviceId");
    if (!deviceIdToUse) {
       deviceIdToUse = "web-" + Math.random().toString(36).substr(2, 9);
    }
    localStorage.setItem("deviceId", deviceIdToUse);

    store.dispatch(setSdkParams({ 
        mobileNumber, 
        userId, 
        deviceId: deviceIdToUse,
        panNumber,
        emailId
    }));
  }, []);

  return (
    <div className="min-h-screen bg-fin-bg text-gray-900">
      <AppRouter />
    </div>
  );
};

export default App;
